import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import template from './action-edit-only-column.pug';

export class ActionEditOnlyColumn extends ProjectionGridBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'Action',
      property: 'Recommendation/ActionEditOnly',
      title: i18n.getString('ColumnName_Action') || 'Action',
      bodyClasses: ['inline-action-view-column'],
      colClasses: ['col-edit'],
    });
    this.i18n = i18n;
  }

  template() {
    const { i18n } = this;
    return template({ i18n });
  }
}
